import { createFileRoute } from '@tanstack/react-router'

import ApiKeysSection from 'pages/Settings/ApiKeysSection'

export const Route = createFileRoute('/_auth/settings/api-keys')({
  component: ApiKeysSection,
})
